
<template>
  <div class="user" id="myuser">
    <div class="userlist-title">
      <div class="user-head">
        <div>账 号 </div>
        <el-input placeholder="账号" v-model="name" class="input-with-select" clearable></el-input>
        <el-button type="primary" size="medium" icon="el-icon-search" @click="search">查 找</el-button>
        <el-button type="primary" size="medium"  icon="el-icon-circle-plus-outline" @click="addInfo">添 加</el-button>
      </div>
    </div>
    <div class="userlist-content"   ref="myHeight">
      <el-table
        :data="tableData"
        tooltip-effect="dark"

        >
        <el-table-column prop="name" label="姓名"  align='center'></el-table-column>
        <el-table-column prop="account" label="账号"  align='center'></el-table-column>
        <!-- <el-table-column prop="phone" label="电话" align='center'></el-table-column> -->
        <el-table-column label="操作"  align='center' width="400">
          <template slot-scope="scope">
            <el-button
              size="mini"
              icon="el-icon-edit-outline"
              type="warning"
              @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button>
            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              @click="handleDelete(scope.$index, scope.row)"
            >删除</el-button>
            <el-button
              size="mini"
              type="warning"
              icon="el-icon-refresh"
              @click="reset(scope.$index, scope.row)"
            >重置密码</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20]"
        :page-size="100"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <div class="updateuser">
      <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
        width="500px"
        :before-close="handleClose">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="50px" class="demo-ruleForm">
              <el-form-item label="账号" prop="account" v-if="isAdd">
                <el-input v-model="ruleForm.account" maxlength=6></el-input>
              </el-form-item>
              <el-form-item label="姓名" prop="name">
                <el-input v-model="ruleForm.name"></el-input>
              </el-form-item>
              <!-- <el-form-item label="号码" prop="phone">
                <el-input v-model="ruleForm.phone"></el-input>
              </el-form-item> -->
              <el-form-item class="mybtn">
                <el-button  @click="cancel('ruleForm')">取 消</el-button>
                <el-button @click="comfir('ruleForm')" type="primary">确 定</el-button>
              </el-form-item>
            </el-form>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
    data () {
      return {
          tableData:[],
          clientHeight:0,
          // border:"",
          name:"",
          total:0,
          searchObj:{
            account:"",
            pageindex:1,
            pagesize:10
          },
          title:"",
          dialogVisible:false,
          ruleForm:{
            account:'',
            name:'',
            phone:''
          },
          rules:{
            name:[{ required: true, message: '请输入姓名', trigger: 'blur' },
                  // { min: 3, max: 8, message: '长度在 3 到 8 个字符', trigger: 'blur' }
            ],
            account:[{ required: true, message: '请输入账号', trigger: 'blur'},
                    // { min: 3, max: 8, message: '长度在 3 到 8 个字符', trigger: 'blur' },
                    { pattern: /^[0-9]{6}$/, message: '请输入正确的账号' }
            ],
            phone:[{ required: true, message: '请输入号码', trigger: 'blur' },
                  { pattern: /^1[34578]\d{9}$/, message: '请输入合法的手机号' }
            ],
          },
          isAdd:true,

     }
   },
    computed:{
    },
    components:{
    },
    watch: {
      // 如果 `clientHeight` 发生改变，这个函数就会运行
      clientHeight: function () {
        this.changeFixed(this.clientHeight)
      },
    },
    mounted(){
      this.clientHeight =   `${document.documentElement.clientHeight}`-220         
      window.onresize = function temp() {
        this.clientHeight = `${document.documentElement.clientHeight}`-220 ;
      };
      //console.log( this.clientHeight)
      this.getUser()

    },
    methods:{
      handleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
        this.searchObj.pagesize=val;
        this.getUser()
      },
      handleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.searchObj.pageindex=val;
        this.getUser()
      },
      changeFixed(clientHeight){ //动态修改样式
        this.$refs.myHeight.style.maxHeight = clientHeight+'px';
      },
      //关闭弹框
      handleClose(){
        this.dialogVisible=false;
      },
      //确认
      comfir(ruleForm){
        //console.log("新增", this.ruleForm)
        if(this.isAdd){//新增
          this.$refs[ruleForm].validate((valid) => {
            if (valid) {
              this.$api.adduser(this.ruleForm,res=>{
                //console.log(res)
                if(res.errCode==0){
                    this.dialogVisible=false;
                    this.getUser()
                    this.ruleForm.account="";
                    this.ruleForm.name="";
                    this.ruleForm.phone="";
                }else{
                  this.$message.error(res.msg)
                  this.dialogVisible=false;
                  this.ruleForm.account="";
                  this.ruleForm.name="";
                  this.ruleForm.phone="";
                }
              })
            } else {
              return false;
            }
          });
        }else{//修改
          this.$refs[ruleForm].validate((valid) => {
            if (valid) {
              this.$api.updateuser(this.ruleForm,res=>{
                //console.log(res)
                if(res.errCode==0){
                    this.dialogVisible=false;
                    this.getUser()
                    this.ruleForm.name="";
                    this.ruleForm.phone="";
                }else{
                  this.$message.error(res.msg)
                  this.dialogVisible=false;
                  this.ruleForm.name="";
                  this.ruleForm.phone="";
                }
              })
            } else {
              return false;
            }
          });
        }
      },
      //取消
      cancel(ruleForm){
        this.$refs[ruleForm].resetFields();
        this.dialogVisible=false;
      },
      //新增
      addInfo(){
        this.title="新增用户";
        this.dialogVisible=true;
        this.isAdd=true;
        this.ruleForm.name='';
        this.ruleForm.phone='';
      },
      //搜索
      search(){
        this.searchObj.account=this.name;
        this.searchObj.pageindex=1;
        this.getUser()
      },
      //获取用户信息
      getUser(){
        this.$api.getmanageuserlist(this.searchObj,res=>{
          //console.log(res)
          res.data.list.forEach((v,i)=>{
            if(v.type==1){
              res.data.list.splice(i,1)
            }
          })
          this.tableData=res.data.list,
          this.total=res.data.allnum-1
        })
      },
      //编辑
      handleEdit(index,row){
        this.title="编辑用户"
        this.isAdd=false;
        this.dialogVisible=true;
        this.ruleForm.name=row.name;
        this.ruleForm.phone=row.phone;
        this.ruleForm.id=row.id
      },
      //删除
      handleDelete(index,row){
        //console.log(row)
        this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.deleteuser({id:row.id},res=>{
            if(res.errCode==0){
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getUser()
            }else{
              this.$message.error("删除失败！")
            }
          })
        })
      },
      //重置
      reset(index,row){
        this.$api.resetpassword({id:row.id},res=>{
          if(res.errCode==0){
            this.$message({
                type: 'success',
                message: '修改成功!'
              });
          }else{
            this.$message.error("修改失败！")
          }
        })
      }
    }
}

</script>
<style scoped>
.userlist-content{
  /* width: 100%; */
  overflow-x: auto;
  margin-top: 35px;
  display: flex;
  overflow-y: auto;
}
  .user{
    padding: 20px;
    width: 80%;
    margin: 0 auto;
  }
  .user-head{
    display: flex;                            
    font-size: 14px;
    margin-bottom: 20px;
    margin: 10px;
  }
  .user-head div:first-child{
    width: 40px;line-height: 40px;margin-right: 10px;
  }
    .user-head div:nth-child(2){
    height: 30px;
    width: 250px;
    margin-right: 50px  ;
  }

.pagination{
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
.updateuser /deep/ .el-input{
  width: 250px;
}
 .updateuser /deep/ .el-dialog__body{
  margin-left: auto;
  margin-right: auto;
}
.updateuser /deep/ .el-form-item__content{
  display: flex;
}
.updateuser /deep/ .el-form-item__label{
  margin-left:10%;
}
.mybtn{
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/userMange.vue